import {
  concatStyleSets,
  IButtonStyles,
  ICheckboxStyles,
  IComboBoxStyles,
  ISpinButtonStyles,
} from "@fluentui/react";

import {
  ActionControlSize,
  modernUxControlsBorderRadius,
} from "@1js/acui-common";
import { AppGalleryStyles } from "@1js/acui-gallery";

export const modernUxRibbonControlsBorderRadius: number =
  modernUxControlsBorderRadius;
export const modernUxRibbonCheckboxBorderRadius: number = 2;
export const modernUxRibbonControlHeight: number = 32;

export const getModernUxRibbonButtonStyles = (): IButtonStyles => {
  return {
    root: {
      borderRadius: modernUxRibbonControlsBorderRadius,
      height: modernUxRibbonControlHeight,
      padding: "0 5px",
    },
    label: {
      marginLeft: 6,
      marginRight: 0,
    },
  };
};

export const getModernUxRibbonFlyoutAnchorStyles = (): IButtonStyles => {
  return concatStyleSets(getModernUxRibbonButtonStyles(), {
    root: {
      paddingRight: 3,
    },
    menuIcon: {
      marginLeft: 6,
      marginRight: 0,
    },
  });
};

export const getModernUxRibbonSplitButtonStyles = (
  size?: ActionControlSize
): IButtonStyles => {
  const modernUxSplitButtonStyles: IButtonStyles = {
    root: {
      height: modernUxRibbonControlHeight,
      paddingLeft: 5,
    },
    splitButtonMenuButton: {
      height: modernUxRibbonControlHeight,
    },
    splitButtonContainer: {
      height: modernUxRibbonControlHeight,
    },
  };

  if (size === ActionControlSize.Large) {
    return concatStyleSets(modernUxSplitButtonStyles, {
      root: {
        borderRadius: `${modernUxRibbonControlsBorderRadius}px ${modernUxRibbonControlsBorderRadius}px 0 0`,
      },
      splitButtonMenuButton: {
        borderRadius: `0 0 ${modernUxRibbonControlsBorderRadius}px ${modernUxRibbonControlsBorderRadius}px`,
      },
    });
  }

  return concatStyleSets(modernUxSplitButtonStyles, {
    root: {
      borderRadius: `${modernUxRibbonControlsBorderRadius}px 0 0 ${modernUxRibbonControlsBorderRadius}px`,
    },
    splitButtonMenuButton: {
      borderRadius: `0 ${modernUxRibbonControlsBorderRadius}px ${modernUxRibbonControlsBorderRadius}px 0`,
    },
  });
};

export const getModernUxRibbonSpinButtonStyles =
  (): Partial<ISpinButtonStyles> => {
    return {
      spinButtonWrapper: {
        borderRadius: modernUxRibbonControlsBorderRadius,
      },
    };
  };

export const getModernUxRibbonComboBoxStyles = (
  id?: string
): Partial<IComboBoxStyles> => {
  switch (id) {
    case "FontSize":
      return {
        root: {
          borderTopRightRadius: modernUxRibbonControlsBorderRadius,
          borderBottomRightRadius: modernUxRibbonControlsBorderRadius,
        },
      };
    case "FontPicker":
    case "FontName":
      return {
        root: {
          borderTopLeftRadius: modernUxRibbonControlsBorderRadius,
          borderBottomLeftRadius: modernUxRibbonControlsBorderRadius,
        },
      };
  }
  return {
    root: {
      borderRadius: modernUxRibbonControlsBorderRadius,
    },
  };
};

export const getModernUxRibbonCheckboxStyles = (): Partial<ICheckboxStyles> => {
  return {
    checkbox: {
      borderRadius: modernUxRibbonCheckboxBorderRadius,
    },
  };
};

export const getModernUxPreviewGalleryStyles =
  (): Partial<AppGalleryStyles> => {
    return {
      galleryContainer: {
        root: {
          borderRadius: modernUxRibbonControlsBorderRadius,
        },
      },
      previewExpandButton: {
        root: {
          borderTopRightRadius: modernUxRibbonControlsBorderRadius,
          borderBottomRightRadius: modernUxRibbonControlsBorderRadius,
        },
      },
    };
  };
